<template>
  <div class="file-preview file-preview-pc" :class="{ static: extType === 'image', 'bg-gray': extType === 'pdf' && folderData.isTurn === 1 }">
    <div class="no-support" v-if="!previewUrl && previewUrl!=-1">此文件不支持预览</div>
    <div v-else-if="extType === 'image'" class="image-viewer">
      <img :src="previewUrl" alt=""/>
    </div>
    <div v-else-if="extType === 'video' || extType === 'audio'" class="image-viewer-video">
      <video
          v-if="folderData.pathUrl"
          style="width: 100%;height: 100%;background: #000"
          :poster="folderData.pathUrl + '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto'"
          :src="folderData.pathUrl"
          controls = "true"
          controlslist="nodownload"
          class="video"
          @contextmenu.prevent
      >
        您的浏览器不支持 video 标签。
      </video>
    </div>
    <div v-else-if="extType === 'pdf' && folderData.isTurn === 1">
      <Flipbook
          class="flipbook"
          :class="type=='pc'?'pxtovw-ignore':''"
          :pages="folderData.turns"
          :singlePage="true"
          ref="flipbook"
      >
      </Flipbook>
    </div>

    <iframe
      v-else-if="previewUrl!='-1'"
      class="file-preview-iframe"
      width="100%"
      height="98%"
      :src="previewUrl"
      frameborder="0"
    ></iframe>
    <div
        :class="{
        'item-button-pc': device == 'pc',
        'item-button-wap': device == 'wap',
      }"
        v-if="!hideButton && !showNeedLoginForm && from!=='visitcard'"
    >
      <div
          :class="{ 'button-pc': device == 'pc', 'button-wap': device == 'wap' }"
          :style="{
          color: extraItem.extras('themecolor.bgcolor'),
          borderColor: extraItem.extras('themecolor.bgcolor'),
        }"
          v-if="extraItem.extras('downloadBtnName.display') == 1"
          @click="onDownloadFile(folderData, folderData.downloadType)"
      >
        {{ extraItem.extras("downloadBtnName.model") }}
      </div>
      <div
          :class="{ 'button-pc': device == 'pc', 'button-wap': device == 'wap' }"
          :style="{
          color: extraItem.extras('themecolor.bgcolor'),
          borderColor: extraItem.extras('themecolor.bgcolor'),
        }"
          v-if="noLogin"
          @click="beforeNeedLoginFormClose()"
      >
        {{ "预览全部内容" }}
      </div>
    </div>
    <!-- 名片小程序里的预览页 -->
    <!-- <div
        :class="{
        'item-button-pc': device == 'pc',
        'item-button-wap': device == 'wap',
      }"
        v-if="!hideButton && !showNeedLoginForm&& from==='visitcard'"
    >
      <div
          :class="{ 'button-pc': device == 'pc', 'button-wap': device == 'wap' }"
          :style="{
          color: extraItem.extras('themecolor.bgcolor'),
          borderColor: extraItem.extras('themecolor.bgcolor'),
        }"
          v-if="extraItem.extras('downloadBtnName.display') == 1"
          @click="visitcardOnDownloadFile(folderData, folderData.downloadType)"
      >
        {{ extraItem.extras("downloadBtnName.model") }}
      </div>
      <div
          :class="{ 'button-pc': device == 'pc', 'button-wap': device == 'wap' }"
          :style="{
          color: extraItem.extras('themecolor.bgcolor'),
          borderColor: extraItem.extras('themecolor.bgcolor'),
        }"
          v-if="noLogin"
          @click="beforeNeedLoginFormClose()"
      >
        登录
      </div>
    </div> -->
    <div
        :class="{
        'item-button-pc': device == 'pc',
        'item-button-wap': device == 'wap',
      }"
        v-if="fromType === 'download' && from==='visitcard'"
    >
      <div
          :class="{ 'button-pc': device == 'pc', 'button-wap': device == 'wap' }"
          :style="{
          color: themeColor || extraItem.extras('themecolor.bgcolor'),
          borderColor: themeColor ||extraItem.extras('themecolor.bgcolor'),
        }"
          @click="toDownloadList()"
      >
        个人中心查看下载文件
      </div>
    </div>
    <van-dialog
        id="need-login-form-wap"
        v-model="showNeedLoginForm"
        title=" "
        show-cancel-button
        cancel-button-text="关闭"
        confirm-button-text="登录"
        @confirm="beforeNeedLoginFormClose"
    >
      <div style="height: 80px; padding: 10px 0px">
        <div style="text-align: center">
          尚未登录，仅能预览部分内容
        </div>
        <div style="text-align: center">登录后可预览全部内容/下载文件</div>
      </div>
    </van-dialog>
    <router-view
        @copyUrlPrompt="onCopyUrlPrompt"
        @downloadByEmail="onDownloadByEmail"
    ></router-view>
    <van-dialog
        id="copy-url-dialog"
        v-model="showCopyUrlPrompt"
        title="提示"
        show-cancel-button
        confirm-button-text="复制"
        @confirm="onConfirmCopy"
    >
      <div class="dialog-content" style="padding: 10px 20px">
        <div>复制下载链接在浏览器打开:</div>
        <div class="copy-url">{{ encodeURIComponent(copyUrl) }}</div>
      </div>
    </van-dialog>
    <van-dialog
        id="download-email-form-wap"
        v-model="showDownloadForm"
        title="文件下载"
        show-cancel-button
        confirm-button-text="提交"
        :before-close="beforeDownloadFormClose"
    >
      <div style="height: 80px; padding: 10px 0px">
        <van-field
            class="email-input pxtovw-ignore"
            v-model="userEmail"
            label="邮箱: "
            placeholder="请输入邮箱地址"
            border
            :error-message="emailErrorMsg"
            @input="onInputEmail"
        />
      </div>
    </van-dialog>
    <van-dialog
        v-model="showDownloadTip"
        title=""
        show-cancel-button
        confirm-button-text="前往查看"
        cancelButtonText="关闭"
        width="260px"
        @confirm="toDownloadList"
    >
      <div style="height: 70px; padding: 20px 40px">
        文件已保存到个人下载列表，是否前往查看？
      </div>
    </van-dialog>
    <!-- 水印 -->
    <div v-if="from==='visitcard'" id="watermarkCanvas" style="width: calc(100% - 30px); height: 87%;position: absolute; top: 50px; pointer-events: none"></div>
  </div>
</template>

<script>
import mixin from "@/mixins/index.js";
import mixinTemplate from "@/mixins/template.js";
import { ck, URLS } from "fire-wind-water";
import { verifyLogin, checkLogin } from "@/common/auth.js";
import { copyToClipboard, validateEmail } from "@/common/utils.js";
import Flipbook from 'flipbook-vue/dist/vue2/flipbook.cjs'
import $ from "jquery";
import URL from "@/assets/conf/setting.json";
import cs from "@/services/commonService";

export default {
  components: { Flipbook},
  name: "FilePreview",
  props: ["fileId", "hideButton", "recodeInteraction", "type"],
  mixins: [mixin, mixinTemplate],
  // components: { Head, Banner },
  data() {
    return {
      previewUrl: "-1",
      extType: "",
      showNeedLoginForm: false,
      previewNum: 3,
      previewFile: {},
      noLogin: false,
      device: document.documentElement.clientWidth >= 768 ? "pc" : "wap",

      // 复制链接
      showCopyUrlPrompt: false,
      copyUrl: "",

      // 邮箱下载表单
      showDownloadForm: false,
      userEmail: ck.cookie("user_email"),
      emailErrorMsg: "",
      downloadFile: {},
      folderData: {},
      from: '',
      schemaId:0,
      showDownloadTip: false,
      path: '',
      registerId: '', // 名片文件预览页，分享人的loginId
      fromType: '', // 从名片小程序文件详情页，点击下载跳转来的
      themeColor: ''
    };
  },
  methods: {
    init() {
      this.schemaId = window.$sk.template.get().common.schemaId;

      if (this.schemaId) {
        let memberInfo = ck.cookie(
            "smarketMember_" + this.schemaId
        );
        this.sessParam = memberInfo ? memberInfo.session : "";
      }

      let tokenInfo = ck.cookie("verifyInfo_" + URLS.getURL("weChatId"));
      //let memberInfo = ck.cookie("smarketMember_" + this.folderData.schemaId);
      this.service
          .getReleaseFile({
            fileId: this.fileId,
            userSess: this.sessParam,

            globalUserId: ck.cookie("globalUserId"),
            openId: tokenInfo? tokenInfo.openId : "",
            sess: this.sessParam,
            markCode:URLS.getURL("markCode") || URLS.getHash("markCode")
          })
          .subscribe(async (data) => {
            if (data.result !== 0) {
              this.$antMessage.warning("未获取到对应文件");
              console.log("未获取到对应文件");
              return;
            }
            // if (data.content && data.content.schemaId) {
            //   let memberInfo = ck.cookie(
            //     "smarketMember_" + data.content.schemaId
            //   );
            //   this.sessParam = memberInfo ? memberInfo.session : "";
            // }
            // if (this.sessParam) {
            //   data = await this.service
            //     .getReleaseFile({
            //       fileId: this.fileId,
            //       userSess: this.sessParam,
            //     })
            //     .toPromise();
            // }
            // if (!this.verifyPermission(this.folderData)) return;
            this.$emit('gettenantId',data.content.tenantId)
            this.folderData = this.cookFileData(data.content);
            if (this.folderData && this.folderData.name) {
              document.title = this.folderData.name;
            }
            this.extType = this.folderData.extType;
            this.previewUrl = this.folderData.previewUrl;

            // this.getContact(this.folderData);
            //debugger;
            if (document.documentElement.clientWidth >= 768) {
              //pc
              //  debugger;
              this.initConfig(
                  data.content.pcConfigId,
                  this.folderData.tenantId
              );
            } else {
              //wap
              //debugger;
              this.initConfig(
                  data.content.wapConfigId,
                  this.folderData.tenantId
              );
            }

            // 是否限制微信端
            if (this.folderData.openType == 1 && !window.$ua.isWeChat) {
              this.showPage = false;
              this.$antMessage.info("请在微信端浏览本页面！", 0);
              window.$sk && window.$sk.loading.hide();
              return;
            }

            if (data.enableShare == 2) {  // 与父级保持一致时,读的是文件夹的配置
              this.shareInfo = {
                imgUrl: 'http:' + this.folderData.shareImageRealPath,
                title: this.folderData.shareTitle,
                desc: this.folderData.description,
                link: window.location.href
              };
              this.getWechatId().then(weChatId => {
                //分享设置
                debugger;
                let apiUrl = URL.template.api.gateway.general;
                window.$swxsdk.initWxSdk(
                  { tenantId: this.folderData.tenantId, weChatId: weChatId },
                  apiUrl
                );
                console.log('this.folderData.enableShare ==== ' + this.folderData.enableShare);
                console.log('this.folderData.upperEnableShare ==== ' + this.folderData.upperEnableShare);
                if (this.folderData.enableShare == '2') {  //与父级保持一致
                  if (this.folderData.upperEnableShare == 1) {  //父级允许分享
                    window.$swxsdk.on("sharer", this.shareInfo);
                    window.$swxsdk.on("sharer_friends", this.shareInfo);
                  } else {
                    window.$swxsdk.on(
                      "hideMenuList",
                      {
                        menuList: [
                          "menuItem:share:appMessage",
                          "menuItem:share:timeline",
                          "menuItem:share:qq",
                          "menuItem:share:weiboApp",
                          "menuItem:share:facebook",
                          "menuItem:share:QZone",
                          "menuItem:copyUrl",
                          "menuItem:openWithQQBrowser",
                          "menuItem:openWithSafari",
                          "menuItem:favorite"
                        ]
                      },
                      function(result) {
                        console.log(result);
                      }
                    );
                    window.$swxsdk.on("hideOptionMenu");
                    console.log('hideOptionMenu---353');
                  }
                } else if (this.folderData.enableShare == 1) {  //允许分享
                  window.$swxsdk.on("sharer", this.shareInfo);
                  window.$swxsdk.on("sharer_friends", this.shareInfo);
                } else {    //禁止分享
                  window.$swxsdk.on(
                    "hideMenuList",
                    {
                      menuList: [
                        "menuItem:share:appMessage",
                        "menuItem:share:timeline",
                        "menuItem:share:qq",
                        "menuItem:share:weiboApp",
                        "menuItem:share:facebook",
                        "menuItem:share:QZone",
                        "menuItem:copyUrl",
                        "menuItem:openWithQQBrowser",
                        "menuItem:openWithSafari",
                        "menuItem:favorite"
                      ]
                    },
                    function(result) {
                      console.log(result);
                    }
                  );
                  window.$swxsdk.on("hideOptionMenu");
                  console.log('hideOptionMenu---380');
                }
              });
            }
            window.$sk && window.$sk.loading.hide();
            //触发检查是否显示登录popup
            if (this.from !== "visitcard") {
              let file = this.folderData;
              if (this.verifyPermission(file, false) === false) {
                this.onNeedLogin({ file });
                this.$emit("showPreviewButton", { show: true });
                this.noLogin = true;
              } else {
                this.$emit("showPreviewButton", { show: false });
                this.noLogin = false;
              }
            }
            if (this.recodeInteraction != '0') {
              let file = {
                tenantId: this.folderData.tenantId,
                fileId: this.fileId,
                weChatId: URLS.getURL("weChatId") ? URLS.getURL("weChatId") : "",
                schemaId: this.schemaId
              };
              this.interactionPreview(file);
            }
            // 加水印
            if (this.from === "visitcard") {
              this.getWatermark();
            }
          });


    },
    getWechatId() {
      let defer = $.Deferred();
      let weChatId = this.folderData.weChatId || this.weChatId;
      if (weChatId != 0) {
        defer.resolve(weChatId);
      } else {
        cs.getDefWeChat({}).subscribe(data => {
          defer.resolve(data.content.weChatId);
        });
      }
      return defer.promise();
    },
    onNeedLogin({ file }) {
      //0是不限制预览
      if (file.previewNum != "0") {
        this.showNeedLoginForm = true;
        this.previewNum = file.previewNum;
        this.previewFile = file;
      }
    },
    beforeNeedLoginFormClose() {
      let data = this.previewFile;
      if (this.from === 'visitcard') {
        window.wx.miniProgram.navigateTo({
          url: this.path + "?tenantId=t" +
                this.folderData.tenantId +
                "&registerFormId=" +
                this.folderData.registerFormId +
                "&schemaId=" +
                this.folderData.schemaId,
        });
      }else if (data.identity == 3) {
        return verifyLogin(data);
      } else {
        return true;
      }
    },
    // 复制链接
    onCopyUrlPrompt({ url }) {
      console.log("# onCopyUrlPrompt..");
      this.showCopyUrlPrompt = true;
      this.copyUrl = url;
    },
    onConfirmCopy() {
      copyToClipboard(this.copyUrl);
      this.$toast("复制成功");
      this.copyUrl = "";
    },

    // 邮箱下载
    onDownloadByEmail({ file }) {
      this.showDownloadForm = true;
      this.downloadFile = file;
      this.userEmail = ck.cookie("user_email");
    },
    // 文件下载
    onDownloadFile(file, downloadType) {
      console.log("# onFileDownload");
      // 判断登录权限
      if (this.verifyPermission(file)) {
        this.handleFileDownload(file, downloadType);
      }
    },
    // 名片小程序 文件下载
    visitcardOnDownloadFile(file, downloadType) {
       // 判断登录权限
      if (file.identity == 3) {
        if (!checkLogin(file.schemaId)) {
          window.wx.miniProgram.navigateTo({
            url: this.path + "?tenantId=t" +
                  this.folderData.tenantId +
                  "&registerFormId=" +
                  this.folderData.registerFormId +
                  "&schemaId=" +
                  this.folderData.schemaId,
          });
          return false;
        }
      }
      // 下载方式 0-发送到邮箱下载 1-浏览器直接下载
      if (downloadType == 0) {
        this.$emit("downloadByEmail", { file });
      } else {
        // 记录下载
        // let memberInfo = ck.cookie(
        //       "smarketMember_" + file.schemaId
        //   );
        // this.service
        //   .recordDownload({
        //     fileId: file.fileId,
        //     tenantId: file.tenantId,
        //     globalUserId: ck.cookie("globalUserId"),
        //     programType: 'miniProgram',
        //     sess: memberInfo ? memberInfo.session : "",
        //   })
        //   .subscribe(() => {})
        // this.showDownloadTip = true;
        
      }
    },
    beforeDownloadFormClose(action, done) {
      if (action === "confirm") {
        // 验证邮箱输入框
        if (!this.userEmail) {
          this.emailErrorMsg = "请填写邮箱";
          done(false);
          return;
        }
        if (validateEmail(this.userEmail)) {
          ck.cookie("user_email", this.userEmail);
          // 发送邮箱下载请求
          let tokenInfo = ck.cookie("verifyInfo_" + this.downloadFile.weChatId);
          let memberInfo = ck.cookie(
              "smarketMember_" + this.downloadFile.schemaId
          );
          let weChatId = this.downloadFile.weChatId || this.weChatId;
          this.service
              .downloadWithEmail({
                email: this.userEmail,
                fileList: [this.downloadFile.fileId],
                globalUserId: ck.cookie("globalUserId"),
                sess: memberInfo ? memberInfo.session : "",
                extra: {
                  tenantId: this.downloadFile.tenantId,
                  instanceId: this.downloadFile.instanceId,
                  memberId: 0,
                  moduleId: this.downloadFile.moduleId,
                  openId: tokenInfo ? tokenInfo.original.openid : "",
                  weChatId: weChatId ? weChatId : "",
                  objInstanceId: "",
                  source: "WAP",
                  url: window.location.href,
                },
              })
              .subscribe((data) => {
                let msgSend = "文件已发送至邮箱";
                let msgReview = "审核通过后将发送至邮箱";
                let msgError = "提交异常";
                if (data.result != 0) {
                  this.$toast.fail(msgError);
                } else if (data.content.isReview == 0) {
                  this.$toast.success(msgSend);
                } else if (data.content.isReview == 1) {
                  this.$vantDialog.alert({
                    title: "提示",
                    message: msgReview,
                  });
                }
                this.downloadFile = {};
                done();
              });
          // this.downloadFile = {}
          // done()
        } else {
          // 提示邮箱错误
          this.emailErrorMsg = "邮箱格式错误";
          done(false);
        }
      } else {
        this.emailErrorMsg = "";
        this.downloadFile = {};
        done();
      }
    },
    onInputEmail() {
      this.emailErrorMsg = "";
    },
    interactionPreview(file) {
      let tokenInfo = ck.cookie("verifyInfo_" + file.weChatId);
      let memberInfo = ck.cookie("smarketMember_" + file.schemaId);
      let weChatId = file.weChatId || weChatId;
      let data = {
        tenantId: file.tenantId,
        fileId: file.fileId,
        source: window.$ua.clientType,
        globalUserId: ck.cookie("globalUserId"),
        sess: memberInfo ? memberInfo.session : "",
        openId: tokenInfo ? tokenInfo.original.openid : "",
        weChatId: weChatId ? weChatId : "",
        currentUrl: window.location.href,
        moduleId: URLS.getURL('moduleId') || URLS.getHash('moduleId'),
        instanceId: URLS.getURL('instanceId') || URLS.getHash('instanceId')
      };
      this.service.interactionPreview(data).subscribe(data => {
        // console.log(data);
        let status = data.content.status;
        if (status == 1) {
          console.log("# interaction preview: sucess.");
        } else {
          console.log("# interaction preview: error.");
        }
      });
  },
    // 跳转到名片小程序 下载文件列表
    toDownloadList() {
      window.wx.miniProgram.navigateTo({
        url: "/pages_client/personalCenter/myDownload",
      });
    },
    // 获取水印内容
    getWatermark() {
      this.service.getWatermark({
        sess: this.$route.query.sess,
        registerId: this.registerId,
        fileExt: this.folderData.ext,
        tenantId: this.folderData.tenantId
      }).subscribe( res => {
        const txt = res.content?.watermark;
        if (txt) {
          const canvas = document.createElement('canvas');
          canvas.width = txt.length*16 < 200 ? 200 : txt.length*16;
          canvas.height = canvas.width*0.7;
          const ctx = canvas.getContext('2d');
          ctx.fillStyle = '#000';
          ctx.globalAlpha = 0.5;
          ctx.font = `12px serif`;
          ctx.textAlign="center";
          ctx.rotate(Math.PI / 180 * -30);
          ctx.fillText(txt, canvas.width*0.2, canvas.height -30);
          $("#watermarkCanvas").css("background-image", `url(${canvas.toDataURL()})`)
        }
      })
    }
  },
  mounted() {
  },
  created() {
    this.from = this.$route.query.from;
    this.path = this.$route.query.path || '/pages_client/register/register';
    if (this.from === 'visitcard') {
      ck.cookie("programUserId", this.$route.query.programUserId);
      ck.cookie("programId", this.$route.query.programId);
      ck.cookie("programType", 'miniProgram')
      this.registerId = this.$route.query.sourceRegisterId;
      this.fromType = this.$route.query.type;
      this.themeColor = this.$route.query.themeColor;
    }

//    window.$sk && window.$sk.loading.show();
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.flipbook {
  width: 100%;
  height: 700px;
  ::v-deep .click-to-flip::before {
    content: '';
  }
  .action-bar .btn.disabled {
    color: #666;
    pointer-events: none;
  }
}
.file-preview {
  &.bg-gray {
    background: #eee;
  }
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 14px 14px 28px ;
  overflow: auto;
  &.pxtovw-ignore {
    position: static;
    padding: 0;
    height: 700px;
    overflow: hidden;
    .image-viewer {
      overflow: hidden auto;
      height: auto;
      max-height: 700px;
      img {
        max-width: 100%;
        max-height: 700px;
        margin: auto;
        display: block;
      }
    }
    .no-support {
      width: 100%;
      height: 392px;
      margin: 15px auto;
      background: #d4d4d4;
      color: #fff;
      font-size: 24px;
      line-height: 392px;
      text-align: center;
    }
  }
  &.static {
    position: static;
    padding: 0;
    //   background-color: rgb(14, 14, 14);
  }
}

.image-viewer {
  display: flex;
  align-items: center;
  max-width: 1200px;
  height: 100vh;
}
.image-viewer-video {
  display: flex;
  align-items: center;
  max-width: 1200px;
  height: 100%;
}
.image-viewer img {
  max-width: 100%;
  max-height: 100vh;
  margin: auto;
  display: block;
}
.file-preview-iframe {
  max-width: 1200px;
}

.no-support {
  width: 100%;
  height: 392px;
  margin: 15px auto;
  background: #d4d4d4;
  color: #fff;
  font-size: 24px;
  line-height: 392px;
  text-align: center;
}

.item-button-pc {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 30px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0px -1px 6px 1px rgba(237, 237, 237, 0.5);

  display: flex;
  align-items: center;
  justify-content: center;
}
.item-button-wap {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0px -1px 6px 1px rgba(237, 237, 237, 0.5);

  display: flex;
  align-items: center;
  justify-content: center;
}
.button-pc {
  display: inline-block;

  /*width: 124px;*/
  min-width: 80px;
  margin-left: 30px;
  height: 23px;
  box-sizing: border-box;
  line-height: 23px;
  text-align: center;
  border: 1px solid $blue;
  border-radius: 4px;
  color: $blue;
  font-weight: 400;
  font-size: 10px;
  background-color: #ffffff;
  cursor: pointer;
  max-width: 330px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding: 0 10px;
  &:first-of-type {
    margin-left: 0;
  }
}
.button-wap {
  display: inline-block;

  /*width: 124px;*/
  min-width: 230px;
  margin-left: 30px;
  height: 68px;
  box-sizing: border-box;
  line-height: 68px;
  text-align: center;
  border: 1px solid $blue;
  border-radius: 4px;
  color: $blue;
  font-weight: 400;
  font-size: 30px;
  background-color: #ffffff;
  cursor: pointer;
  max-width: 330px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding: 0 10px;
  &:first-of-type {
    margin-left: 0;
  }
}
</style>
